import * as React from 'react';

type ToastKind = 'success' | 'error' | 'info';

export function useToast() {
  const [message, setMessage] = React.useState<string | null>(null);
  const [type, setType] = React.useState<ToastKind>('info');

  const toast = React.useCallback((msg: string, kind: ToastKind = 'info') => {
    setMessage(msg);
    setType(kind);
    setTimeout(() => setMessage(null), 3000);
  }, []);

  const Toaster = React.useCallback(() => {
    if (!message) return null;
    const color = type === 'success' ? 'bg-green-600 text-white' : type === 'error' ? 'bg-red-600 text-white' : 'bg-zinc-700 text-foreground';
    return (
      <div className="fixed bottom-4 right-4 z-50">
        <div className={`rounded-md px-4 py-2 shadow-lg ${color}`}>{message}</div>
      </div>
    );
  }, [message, type]);

  return { toast, Toaster };
}


